import { render, staticRenderFns } from "./sonDevice.vue?vue&type=template&id=85812956&scoped=true&"
import script from "./sonDevice.vue?vue&type=script&lang=js&"
export * from "./sonDevice.vue?vue&type=script&lang=js&"
import style0 from "./sonDevice.vue?vue&type=style&index=0&id=85812956&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85812956",
  null
  
)

export default component.exports